export const fromEntries = (entries) => {
    return entries.reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
    }, {});
};
//# sourceMappingURL=fromEntries.js.map
// @zapier/design-system@5.18.1 (f78072c92)
